// removed by extract-text-webpack-plugin
module.exports = {"progress":"_1LbRQIZ5TwLYcbNtyNYUpY","spin":"_3o41I_aiAbqJJm8zBu6jT3"};


//////////////////
// WEBPACK FOOTER
// ./src/v2SPRINTA/atoms/Loading/style.module.css
// module id = 358
// module chunks = 39